import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Parameters from 'shared/parameters';
import MyCourses from 'views/MyCourses/MyCourses';
// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      genDict: {
        addedToTheCard: 'Item added into the cart',
        WhoBroughtInstructor : 'Course Student',
        organization: 'Organization',
        certificate: 'Certificate',
        ADMIN: 'ADMIN',
        Paragraph2:'  Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.',
        IntermediateInWebDevelopment:'Intermediate in Web Development',
        Message:'Message',
        LessionParagraph:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        Graduated:'Graduated',
        Startlearning:'Start learning',
        Red:'Red',
        MarketingParagraph:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen',
        PurchaseDate:'Purchase Date',
        Orange:'Orange',
        Green:'Green',
        GraphicDesign:'Graphic Design',
        Default:'Default',
        ForgotPassword:'Forgot Password?',
        courses: 'Courses',
        ScheduleDate:'Schedule Date',
        ContentReportsOf:'Content Reports of',
        loginNeeded: 'Login Needed',
        levels: 'Levels',
        DigitalMarketing:'Digital Marketing',
        SellingPrice:'Selling Price',
        banners: 'Banners',
        // banners:'Create Banner',
        Watch:'Watch',
        CreateBanner:'Create Banner',
        RememberMe:'Remember me',
        badges: 'Badges',
        users: 'Users',
        admins: 'Admins',
        students: 'Students',
        instructors: 'Instructors',
        admin: 'Admin',
        Read:'Read',
        content: 'Content',
        Limitedtimeoffer:"Limited time offer",
        packages: 'Packages',
        staticPages: 'Static Pages',
        ordersReport: 'Orders Report',
        reports: 'Reports',
        instructorsReport: 'Instructors Report',
        learnersReport: 'Learners Report',
        studentsReport: 'Students Report',
        coursesReport: 'Courses Report',
        createdAt: 'Created At',
        by: 'By',
        Active:'Active',
        login: 'Login',
        select: 'Select',
        male: 'Male',
        female: 'Female',
        status: 'Status',
        payment_method: 'Payment Method',
        email: 'Email',
        phone: 'Phone',
        transactionId: 'Transaction Id',
        createdDate: 'Created At',
        items: 'Items',
        BacklogNumber:'Backlog number',
        Benefits:'Benefits',
        course: 'Course',
        review: 'Review',
        rating: 'Rating',
        minutes: 'mins',
        filter: 'Filter',
        category: 'Category',
        level: 'Level',
        plan: 'Plan',
        skillLevel: 'Skill Level',
        viewCourse: 'View Course',
        description: 'Description',
        duration: 'Duration',
        lectures: 'Lectures',
        resources: 'Resources',
        search: 'Search',
        curriculums: 'Curriculums',
        curriculum: 'Curriculum',
        reviews: 'Reviews',
        preview: 'Preview',
        TeachingCourse:'Teaching Course',
        explore: 'Explore',
        register: 'Register',
        applyNow: 'Apply Now',
        connect: 'Login',
        exploreCourses: 'Explore Courses',
        image: 'Image',
        title: 'Title',
        price: 'Price',
        action: 'Action',
        profile: 'Profile',
        orders: 'Orders',
        calender: 'Calender',
        myReviews: 'My Reviews',
        logout: 'Logout',
        meetings: 'Meetings',
        myCourses: 'My Courses',
        categories: 'Categories',
        changePassword: 'Change Password',
        updateProfile: 'Update Profile',
        copyRight: 'Copyright',
        about: 'About',
        contact: 'Contact',
        termsOfUse: 'Terms of use',
        privacyPolicy: 'Privacy policy',
        name: 'Name',
        domain: 'Domain',
        confirmDelete: 'Confirm Delete',
        isClosed: 'Closed',
        ok: 'Ok',
        cancel: 'Cancel',
        descriptionParagraph: 'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.',
        success: 'Success',
        Paragraph3:'Learn new skills and Grow higher in your career',
        organizations: 'Organizations',
        add: 'Add',
        addOption: 'Add Option',
        save: 'Save',
        cancel: 'Cancel',
        uploadLogo: 'Upload Logo',
        remove: 'Remove',
        paymentMethod: 'Payment Method',
        salePrice: 'Sale Price',
        gender: 'Gender',
        Clickstartwhenyouready:'Click start when you re ready',
        numberOfCourses: 'Number Of Courses',
        coursesPurchased: 'Courses Purchased',
        coursesCompleted: 'Courses Completed',
        quizCompleted: 'Quiz Completed',
        packagePurchaseCount: 'Package Purchase Count',
        author: 'Author',
        isFeatured: 'Featured',
        Featured: 'Featured',
        numberOfCurriculums: 'Number Of Curriculums',
        numberOfContents: 'Number Of Contents',
        numberOfPurchases: 'Number Of Purchases',
        resetPassword: 'Reset Password',
        STUDENT: 'STUDENT',
        INSTRUCTOR: 'INSTRUCTOR',
        type: 'Type',
        uploadAvatar: 'Upload Avatar',
        required: 'Required',
        uploadImage: 'Upload Image',
        resetAll: 'reset All',
        path: 'Path',
        user: 'User',
        isPopular: 'Popular',
        Popular: 'Popular',
        free: 'Free',
        paid: 'Paid',
        view: 'View',
        ratings: 'Ratings',
        reviews:'Reviews',
        sortOrder: 'Sort Order',
        isRecordingOn: 'Recording On',
        startDate: 'Start Date',
        endDate: 'End Date',
        Browsecoursebycategory:'Browse course by category',
        upload: 'Upload',
        contents: 'Contents',
        uploadVideo: 'Upload Video',
        uploadPDF: 'Upload PDF',
        uploadDocument: 'Upload Document',
        uploadSCORM: 'Upload SCORM',
        uploadHTML: 'Upload HTML',
        questions: 'Questions',
        ContinuetoVideo:'Continue to Video',
        join: 'Join',
        noResultFound: 'No Result Found',
        getThisCourse: 'Get This Course',
        actualPrice: 'Actual Price',
        noContentAvailable: 'No Content Available',
        addedToTheCart: 'Added To The Cart',
        checkout: 'checkout',
        totalPrice: 'Total Price',
        discount: 'Discount',
        total: 'Total',
        pay: 'Pay',
        AnishaParveen:'Anisha Parveen',
        reviewParagraph:'This is review title. It will be displayed here and content below is the review',
        WhatOurStudentsaying:'WhatOurStudentsaying',
        reviewParagraph1:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen Sylter Deich. Vogel Quax zwickt Johnys Pferd Bim. Sylvia wagt quick den Jux bei Pforzheim. Polyfon zwitschernd aßen Mäxchens Vögel Rüben, Joghurt und Quark. "Fix, Schwyz!" quäkt Jürgen blöd vom Paß. Victor jagt zwölf Boxkämpfer quer',
        submit: 'Submit',
        results: 'Results',
        freeCoursesAllowedInPackages: 'Free Courses Allowed In Packages',
        getPlan: 'Get Plan',
        uploadAvtar: 'Upload Avatar',
        paragraph:'This Information will be display the identify of the administrator',
        student_information:'Students Information',
        student_paragraph:'This Information will be display the identify of the administrator',
        security:'Security',
        security_paragraph:'This Information will be display the identify of the administrator',
        instructor_information:'Instructor s Information',
        uploadBage:'Upload Badge',
        uploadParagraph:'This Information will be display the logo of the organisation',
        badgeInformation:'Badge Information',
        badgeInformationParagraph:'This Information will be display the logo of the organisation',
        uploadBanner:'Upload Banner',
        uploadBannerParagraph:'This Information will be display the logo of the organisation',
        bannerInformation:'Banner Information',
        bannerInformatioParagraph:'This Information will be display the logo of the organisation',
        levelInformation:'Levels Information',
        levelInformationParagraph:'This Information will be display the logo of the organisation',
        UploadImage:'Upload Image',
        UploadImageParagraph:'This Information will be display the logo of the organisation',
        CategoryInformation:'Categorys Information',
        CategoryInformationParagraph:'This Information will be display the identify of the administrator',
        selectCategory:'Select Category',
        selectCategoryParagraph:'This Information will be display the identify of the administrator',
        saveAndContinue:'Save and Continue',
        SelectCourseLevel:'Select Course Level',
        SelectCourseLevelParagraph:'This Information will be display the identify of the administrator',
        UploadCourseThumbnail:'Upload Course Thumbnail',
        UploadCourseThumbnailParagraph:'This Information will be display the logo of the organisation',
        CourseInformation:'Course Information',
        CourseInformationParagraph:'This information will be display the identify of the administrator',
        CourseInstructor:'Course Instructor',
        Classification:'Classification',
        CoursePlane:'Course Plan',
        ModuleInformation:'Module Information',
        AddModule:'Add Module',
        Writeareview:'Write a review',
        Exit:'Exit',
        Lession:'Lession',
        IntroductionOfGraphicDesign:'Introduction of Graphic Design',
        Module:'Module',
        DiplomaInWebDevelopment:'Diploma in Web Development',
        addQuize:'Add Quize',
        addContent:'Add Content',
        contentInformation:'Content Information',
        AddContent:'Add Content',
        QuizeQuestion:'Quiz Questions',
        AddQuestions:'Add Questions',
        NoContentYet:'No content yet!!',
        SaveCategoryandExit:'Save Category and Exit',
        addnewcategory:'add new category',
        SaveAsDraft:'Save as Draft',
        SearchCourse:'Search Course',
        EnterCourseTitle:'Enter Course Title',
        AddCourse:'Add Course',
        Step1:'STEP 1',
        Step2:'STEP 2',
        Step3:'STEP 3',
        Step4:'STEP 4',
        SelectCreateACategory:'SELECT / CREATE A CATEGORY',
        Select_SelectLevel:'SELECT / SELECT LEVEL',
        CreateCourse:'CREATE COURSE',
        Add_Content:'ADD CONTENT',
        Or:'Or',
        Module:'Module',
        Title:'Title',
        Content:'Content',
        Quiz:'Quiz',
        AddStudent:'Add Student',
        AddInstructor:'Add Instructor',
        AddBages:'Add Badge',
        AddBanner:'Add Banner',
        Category:'Add Category',
        AddLevel:'Add Level',
        ViewDetail:'View Detail',
        Gobacktocourse:'Go back to course',
        Gobacktocontentlist:'Go back to content list',
        Module:'Module',
        h:'h',
        Enrolled:'Enrolled',
        Assignment:'Assignment',
        trainingSchedule: 'Training Schedule',
        Lectures:'Lectures',
        Module:'Module',
       CirclumEdit:'curriculum.edit',
       Go:'Go',
       Find_Your_Course:'Find your course',
       curriculum:'Curriculum',
       curriculumParagraph:'A quality education has the power to change the world. Choose us for better future.',
       Explore:'Explore',
       Home:'Home',
       AllCourses:'All Courses',
       Footer:'© 2026 Tecziq Solutions pvt. ltd, All rights reserved',
       MyCourse:'My Course',
       Reviews:'Reviews',
       MyBadges:'My Badges',
       YourProfile:'Your Profile',
       EmailAddress:'Email Address',
       PhoneNumber:'Phone Number',
       EnrolledCourse:'Enrolled Course',
       GraduatedIn:'Graduated in',
       Badge:'Badge',
       Information:'Information',
       Edit:'Edit',
       editProfile:'Edit Profile',
       CreatedOn:'Created on',
       MyCourse:'My Courses',
       delete:'Delete',
       YourReviews:'Your Reviews',
       MoreDetail:'More Details',
       AboutThisCourse:'About This Course',
       ViewAdd:'View/Add',
       Instructor:'Instructor',
       CourseCompletion:'Course Completion',
       Completed:'Completed',
       YourBadge:'Your Badge',
       COURSE:'COURSE',
       CourseName:'Course Name',
       StudentName:'Student Name',
       ReviewDate:'Review Date',
       AddIn:'Added In',
       InstructorName:'Instructor Name',
       Badge:'Badge',
       NoOfCourse:'No. of course',
       SearchCategory:'Search Category',
       SubCategory:'Sub Category',
       EnterCategoryName:'Enter Category Name',
       TotalContent:'Total Content',
       TotalContentInCourse:'Total Content in course',
       CompletedContent:'Completed Content',
       CompletedContentParagraph:'Total completed count of the course content',
       CompletionPercentage:'Completion Percentage',
       CompletionPercentageParagraph:'Completion percentage of all contents',
       TotalQuiz:'Total Quiz',
       TotalQuizParagraph:'Total quiz in course',
       CompletedQuiz:'Completed Quiz',
       CompletedQuizParagraph:'Total completed count of the course quiz',
       CompletionPercentage:'Completion Percentage',
       CompletionPercentage:'Completion Percentage of all quizes',
       QuizPerformance:'Quiz Performance',
       QuizTitle:'Quiz Title',
       UserScore:'User Score',
       TotalScore:'Total Score',
       ScorePercentage:'Score Percentage',
       CompletedContents:'Completed Contents',
       ContentType:'Content Type',
       NoOfCourses:'No. of Courses',
       ContactInfo:'contact info',
       DateOfJoining:'date of joining',
       CompletedCourses:'Completed Courses',
       CourseContent:'Course Content',
       video:'video',
       Pdf:'pdf',
       Ppt:'ppt',
       Quiz:'quiz',
       EnrolledStudents:'Enrolled Students',
       CompletePercentage:'complete percentage',
       SubscribedAt:'Subscribed At',
       CompletedAt:'Completed At',
       dataTableSearch: 'Search',
       emptyTable: 'No data available in table',
       Show:'Show',
       entries:'entries',
       infoEmpty:'Showing 0 to 0 of 0 entries',
       Showing:'Showing',
       PermissionDenied:'Permission Denied',
       QuestionTitle:'Question Title',
       first: "First",
        last:"Last",
        next:"Next",
        previous:"Previous",
        SeeQuestions:'See Questions',
        BrowseCourse:'Browse Course',
        Overview:'Overview',
        GloballyRecognised:'P.O.S.H. Act of India compliant',
        GetCertified:'Get Certified',
        yourScore: 'Your Score',
        start:'start',
        clickedCourses: 'Clicked Courses',
        userClicked: 'User Clicked',
        CourseClickCount: 'Click Count',
        loggedinUser: 'Loggedin User',
        guestUser: 'Guest User',
        courseClicked: 'Course Clicked',
        instructorRatings: 'Instructor Ratings',
        InsRatingsReviews: 'Ratings/Reviews',
        Course: 'Course',
        yourReviews: 'Your Reviews',
        student: 'Student',
        wrongQuestionReport: 'Wrong Question Report',
        question: 'Question',
        module:'Module',
        wrongMarked: 'Wrong Marked',
        updatedAt: 'Updated At',
      },
      adminInsRating: {
        userName: 'User Name',
        insName: 'Instructor Name',
        rating: 'Rating',
        review: 'Review',
        status: 'Status',
        createdAt: 'Created At',
      },
      name: {
        label: 'Name',
        required: 'Name Required',
      },
      description: {
        label: 'Description',
        required: 'Description Required',
      },
      image: {
        label: 'Image',
        required: 'Image Required',
      },
      active: {
        label: 'Active',
        required: 'Active Required',
      },
      title: {
        label: 'Title',
        required: 'Title Required',
      },
      questions:{
        label: 'Question',
        required: 'Question Required',
      },
      shortDescription: {
        label: 'Short Description',
        required: 'Short Description Required',
      },
      benefits: {
        label: 'Benefits',
        required: 'Benefits Required',
      },
      minLength20: {
        required: 'Minimum length 20 Required',
      },
      home: {
        registerBannerText: 'Start Quick learning, Register Now!',
        searchByCategory: 'Search by category',
        registerBannerDescription: `Top instructors from around the world teach millions of students on ${Parameters.clientName}. Enroll today and start learning.`,
        featuredCourses: 'Top featured courses',
        popularCourses: 'Popular courses',
        coursesByTopCategories: 'The world\'s largest selection of courses\n',
        coursesByTopCategoriesDescription: 'Choose from 155,000 online video courses with new additions published every month',
        ourPlans: 'Our Plans',
        ourTeachers: 'Meet The Best Teachers',
        VideoQuiz:'Video Quiz',
        showQuestion:'Video Quiz'
      },
      student: {
        create: 'create student',
      },
      instructor:{
        create:'instructor create'
      },
      register: {
        connect: 'Register',
        changePassword: 'Change Password',
        name: {
          label: 'Name',
          required: 'Name Required',
        },
        email: {
          label: 'Email',
          required: 'Email Required',
        },
        phone: {
          label: 'Phone',
          required: 'Phone Required',
        },
        gender: {
          label: 'Gender',
          required: 'Gender Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
        password_confirmation: {
          label: 'Confirm Password',
          required: 'Confirm Password Required',
        },
      },
      resetPassword: {
        reset: 'Reset Password',
        email: {
          label: 'Email',
          required: 'Email Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
        password_confirmation: {
          label: 'Confirm Password',
          required: 'Confirm Password Required',
        },
      },
      organization: {
        // frontDomain: 'Front Domain',
        // hasBBB: 'Has BBB',
        create: 'Organization Create',
        paypalCredentials: 'Paypal Credentials',
        name: {
          label: 'Name',
          required: 'Name Required',
        },
        theme: {
          label: 'Theme'
        },
        homeTitle: {
          label: 'Home Title'
        },
        homeDescription: {
          label: 'Home Description'
        },
        email: {
          label: 'Email',
          required: 'Email Required',
        },
        domain: {
          label: 'Domain',
          required: 'Domain Required',
        },
        frontDomain: {
          label: 'Front Domain',
          required: 'Front Domain Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
        password_confirmation: {
          label: 'Confirm Password',
          required: 'Confirm Password Required',
        },
        isClosed: {
          label: 'Closed',
        },
        hasBBB: {
          label: 'Has BBB',
        }
        ,
        description: {
          label: 'Description',
          required: 'Description Required',
        },
        image: {
          required: 'Organization Image Required',
        },
      },
      report: {
        order_status: 'Order Status',
      },
      login: {
        connect: 'Login',
        email: {
          label: 'Email Address',
          required: 'Email Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
      },
      profile: {
        update: 'Update',
        changePassword: 'Change Password',
        name: {
          label: 'Name',
          required: 'Name Required',
        },
        email: {
          label: 'Email',
          required: 'Email Required',
        },
        phone: {
          label: 'Phone',
          required: 'Phone Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
        password_confirmation: {
          label: 'Confirm Password',
          required: 'Confirm Password Required',
        },
        gender: {
          label:  "Gender",
          required:"Gender Required",
        }
      },
      user: {
        type: {
          label: 'Type',
          required: 'Type Required',
        },
        category: {
          label: 'Category',
          required: 'Category Required',
          placeholder: 'Please Select',
        },

        name: {
          label: 'Name',
          required: 'Name Required',
        },
        email: {
          label: 'Email',
          required: 'Email Required',
        },
        phone: {
          label: 'Phone',
          required: 'Phone Required',
        },
        gender: {
          label: 'Gender',
          required: 'Gender Required',
        },
        jobTitle: {
          label: 'Job Title',
          required: 'Job Title Required',
        },
        aboutMe: {
          label: 'About Me',
          required: 'About Me Required',
        },
        password: {
          label: 'Password',
          required: 'Password Required',
          minLength6: 'Minimum 6 Characters Required',
          unmatched: 'Password Unmatched',
        },
        password_confirmation: {
          label: 'Confirm Password',
          required: 'Confirm Password Required',
        },
        image: {
          label: 'Image',
          required: 'User Image Required',
        },
      },
      badge: {
        create: 'Create Badge',
        numberOfCourses: {
          label: 'Number Of Courses',
          required: 'Number Of Courses Required',
        },
        edit:'Edit Badge',
        profile:'Badge Profile',
      },
      banner: {
        create: 'Create Banner',
        profile:'Banner Profile'
      },
      banners: {
        create: 'Create Banner',
      },
      package: {
        create: 'Create Package',
        price: {
          label: 'Price',
          required: 'Price Required',
        },
        salePrice: {
          label: 'Sale Price',
          required: 'Sale Price Required',
        },
        numberOfCourses: {
          label: 'Number Of Courses',
          required: 'Number Of Courses Required',
        },
        validity: {
          label: 'Validity',
          required: 'Validity Required',
        },
        validityInMonths: {
          label: 'Validity in months',
          required: 'Validity Required',
        },
        image: {
          label: 'Image',
          required: 'Banner Image Required',
        },
      },
      category: {
        create: 'Create Category',
        choose: 'Choose Category',
      },
      page: {
        create: 'Create Page',
        titleDe: {
          label: 'Title In German',
          required: 'Title Required',
        },
        title: {
          label: 'Title In English',
          required: 'Title Required',
        },
        descriptionDe: {
          label: 'Description In German',
          required: 'Description Required',
        },
        description: {
          label: 'Description In English',
          required: 'Description Required',
        },
        path: {
          label: 'Path',
          required: 'Path Required',
        },
        type: {
          label: 'Type',
          required: 'Type Required',
        },
        numberOfCourses: {
          label: 'Number Of Courses',
          required: 'Number Of Courses Required',
        },

        image: {
          label: 'Image',
          required: 'Badge Image Required',
        },
      },
      level: {
        create: 'Create Level',
        choose: 'Choose Level',
      },
      course: {
        create: 'Create Course',
        addedToFavSuccessfully: 'Added To Favourite Successfully',
        removedFromFavSuccessfully: 'Removed From Favourite Successfully',
        linkCopiedSuccessFully: 'Link Copied Successfully',
        failed: 'Failed',
        average: 'Average',
        good: 'Good',
        excellent: 'Excellent',
        yourScore: 'Your Score',
        totalScore: 'Total Score',
        percentage: 'Percentage',
        response: 'Response',
        plan: {
          label: 'Plan',
          required: 'Plan Required',
        },
        instructor: {
          label: 'Instructor',
          required: 'Instructor Required',
        },
        level: {
          label: 'Level',
          required: 'Level Required',
        },
        category: {
          label: 'Category',
          required: 'Category Required',
        },
        isFeatured: {
          label: 'Featured',
          required: 'Featured Required',
        },
        isPopular: {
          label: 'Popular',
          required: 'Popular Required',
        },
        price: {
          label: 'Price',
          required: 'Price Required',
        },
        salePrice: {
          label: 'Sale Price',
          required: 'Sale Price Required',
          lessThanPrice: 'Sale price should be less than Price',
        },
        image: {
          label: 'Image',
          required: 'Course Image Required',
        },
      },
      meeting: {
        create: 'Create Meeting',
        titleDe: {
          label: 'Title In German',
          required: 'Title Required',
        },
        title: {
          label: 'Title In English',
          required: 'Title Required',
        },
        descriptionDe: {
          label: 'Description In German',
          required: 'Description Required',
        },
        description: {
          label: 'Description In English',
          required: 'Description Required',
        },
        isRecordingOn: {
          label: 'Recording On',
          required: 'Recording On Required',
        },
        startDate: {
          label: 'Start Date',
          required: 'Start Date Required',
          shouldBeGreaterThanToday: 'Start Date Should Be Greater Than Today',
        },
        endDate: {
          label: 'End Date',
          required: 'End Date Required',
        },

        image: {
          label: 'Image',
          required: 'Meeting Image Required',
        },
      },
      curriculum: {
        create: 'Create Curriculum',
        edit:'edit.Curriculum',
        titleDe: {
          label: 'Title In German',
          required: 'Title Required',
        },
        title: {
          label: 'Title In English',
          required: 'Title Required',
        },
        descriptionDe: {
          label: 'Description In German',
          required: 'Description Required',
        },
        description: {
          label: 'Description In English',
          required: 'Description Required',
        },
        isRecordingOn: {
          label: 'Recording On',
          required: 'Recording On Required',
        },
        sortOrder: {
          label: 'Sort Order',
          required: 'Sort Order Required',
        },
        image: {
          label: 'Image',
          required: 'Curriculum Image Required',
        },
      },
      content: {
        create: 'Create Content',
        assignment: 'Assignment',
        scorm: 'Scorm',
        quiz: 'Quiz',
        html: 'HTML',
        external_url: 'External URL',
        vimeo_url: 'Vimeo URL',
        youtube_url: 'YouTube URL',
        titleDe: {
          label: 'Title In German',
          required: 'Title Required',
        },
        title: {
          label: 'Title In English',
          required: 'Title Required',
        },
        descriptionDe: {
          label: 'Description In German',
          required: 'Description Required',
          minLength20: 'At least 20 Characters Required',
        },
        description: {
          label: 'Description In English',
          required: 'Description Required',
          minLength20: 'At least 20 Characters Required',
        },
        isPreview: {
          label: 'Preview',
          required: 'Preview Required',
        },
        type: {
          label: 'Type',
          required: 'Type Required',
        },
        sortOrder: {
          label: 'Sort Order',
          required: 'Sort Order Required',
        },
        lectureType: {
          label: 'Lecture Type',
          required: 'Lecture Type Required',
        },
        lecture: {
          label: 'Lecture',
          video_id: 'Video Id',
          external_url: 'External URL',
          vimeo_url: 'Vimeo URL',
          youtube_url: 'youtube URL',
        },
        generalInstructions: {
          label: 'General Instructions',
          required: 'General Instructions Required',
          minLength20: 'At least 20 Characters Required',
        },
        image: {
          label: 'Image',
          required: 'Content Image Required',
        },
      },
      courses: {
        purchaseCourseFirst: 'Purchase Course First'
      },
      question: {
        create: 'Create Questions',
        singleSelect: 'Single Select',
        multiSelect: 'Multi Select',
        numeric: 'Numeric',
        titleDe: {
          label: 'Title In German',
          required: 'Title Required',
        },
        title: {
          label: 'Title In English',
          required: 'Title Required',
        },
        descriptionDe: {
          label: 'Description In German',
          required: 'Description Required',
        },
        description: {
          label: 'Description In English',
          required: 'Description Required',
        },
        type: {
          label: 'Type',
          required: 'Type Required',
        },
        positiveMarks: {
          label: 'Positive Marks',
          required: 'Positive Marks Required',
        },
        negativeMarks: {
          label: 'Negative Marks',
          required: 'Negative Marks Required',
        },
        option: {
          isCorrect: {
            label: 'Is Correction Option',
          },
          title: {
            label: 'Title',
            required: 'Title Required',
          },
        },
        image: {
          label: 'Image',
          required: 'Question Image Required',
        },
      },
      review: {
        label: 'Review',
        required: 'Review Required',
      },
      rating: {
        label: 'Rating',
        required: 'Rating Required',
      },
    },
  },
  de: {
    translation: {
      genDict: {
        addedToTheCard: 'Artikel in den Warenkorb gelegt',
        WhoBroughtInstructor : 'Cursus student',
        certificate: 'Certificate-DE',
        ADMIN: 'ADMIN',
        Message:'Nachricht',
        Red:'Rot',
        applyNow: 'Jetzt bewerben',
        Paragraph3:'Erlernen Sie neue Fähigkeiten und wachsen Sie in Ihrer Karriere höher',
        Paragraph2:'Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.',
        IntermediateInWebDevelopment:'Mittelstufe in der Webentwicklung',
        LessionParagraph:'Lorem Ipsum ist einfach Blindtext der Druck- und Satzindustrie. Lorem Ipsum ist einfach Blindtext der Druck- und Satzindustrie. Lorem Ipsum ist einfach Blindtext der Druck- und Setzindustrie Lorem Ipsum ist einfach Blindtext der Druck- und Setzindustrie. Lorem Ipsum ist einfach Blindtext der Druck- und Satzindustrie. Lorem Ipsum ist einfach Blindtext der Druck- und Satzindustrie',
        IntroductionOfGraphicDesign:'Einführung in das Grafikdesign',
        DiplomaInWebDevelopment:'Diplom in Webentwicklung',
        descriptionParagraph: 'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz. Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.',
        Graduated:'Abgeschlossen',
        GetCertified:'Zertifiziert werden',
        GloballyRecognised:'Weltweit anerkannt',
        Startlearning:'Beginne zu lernen',
        MarketingParagraph:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen',
        DigitalMarketing:'Digitales Marketing',
        BrowseCourse:'Kurs durchsuchen',
        SellingPrice:'Verkaufspreis',
        Green:'Grün',
        SubCategory:'Unterkategorie',
        GraphicDesign:'Grafik-Design',
        PurchaseDate:'Kaufdatum',
        CreateBanner:'Banner erstellen',
        organization: 'Organization',
        courses: 'Kurse',
        Read:'Lesen',
        Orange:'Orange',
        Default:'Standard',
        ScheduleDate:'Plandatum',
        BacklogNumber:'Rückstandsnummer',
        ContentReportsOf:'Inhaltsberichte von',
        Writeareview:'Eine Rezension schreiben',
        Watch:'Betrachten',
        ForgotPassword:'Passwort vergessen?',
        Popular: 'Beliebt',
        MoreDetail:'Mehr Details',
        loginNeeded: 'Anmeldung erforderlich',
        getPlan: 'Plan bekommen',
        levels: 'Ebenen',
        TeachingCourse:'Lehrgang',
        AnishaParveen:'Anisha Parven',
        banners: 'Banner',
        // banners:'Banner erstellen',
        badges: 'Abzeichen',
        users: 'Benutzer',
        admin: 'Administrator',
        content: 'Inhalt',
        packages: 'Pakete',
        staticPages: 'Statische Seiten',
        ordersReport: 'Auftragsbericht',
        reports: 'Berichte',
        instructors:'Ausbilder',
        instructorsReport: 'Lehrerbericht',
        learnersReport: 'Lernerbericht',
        studentsReport: 'Schülerbericht',
        coursesReport: 'Kursbericht',
        createdAt: 'Hergestellt in',
        students:'Studentinnen',
        by: 'Durch',
        login: 'Anmeldung',
        select: 'Wählen',
        male: 'Männlich',
        female: 'Weiblich',
        status: 'Status',
        payment_method: 'Zahlungsmethode',
        email: 'Email',
        phone: 'Telefon',
        transactionId: 'Transaktions-ID',
        createdDate: 'Hergestellt in',
        items: 'Artikel',
        review: 'Rezension',
        rating: 'Bewertung',
        minutes: 'Minuten',
        filter: 'Filter',
        category: 'Kategorie',
        level: 'Niveau',
        plan: 'Planen',
        skillLevel: 'Fähigkeits Level',
        viewCourse: 'Kurs ansehen',
        description: 'Beschreibung',
        duration: 'Dauer',
        lectures: 'Vorträge',
        resources: 'Ressourcen',
        search: 'Suche',
        curriculums: 'Lehrpläne',
        curriculum: 'Lehrplan',
        reviews: 'Bewertungen',
        preview: 'Vorschau',
        explore: 'Erkunden',
        register: 'Registrieren',
        applyNow: 'Jetzt bewerben',
        connect: 'Anmeldung',
        exploreCourses: 'Kurse erkunden',
        image: 'Bild',
        title: 'Titel',
        price: 'Preis',
        action: 'Aktion',
        profile: 'Profil',
        orders: 'Aufträge',
        calender: 'Kalender',
        myReviews: 'Meine Bewertungen',
        logout: 'Ausloggen',
        meetings: 'Treffen',
        myCourses: 'Meine Kurse',
        categories: 'Kategorien',
        changePassword: 'Kennwort ändern',
        updateProfile: 'Profil aktualisieren',
        copyRight: 'Urheberrechte',
        about: 'Über',
        contact: 'Kontakt',
        termsOfUse: 'Nutzungsbedingungen',
        privacyPolicy: 'Datenschutz-Bestimmungen',
        name: 'Name',
        domain: 'Domain',
        confirmDelete: 'Löschen bestätigen',
        isClosed: 'Geschlossen',
        ok: 'OK',
        cancel: 'Stornieren',
        success: 'Erfolg',
        organizations: 'Organisationen',
        add: 'Hinzufügen',
        addOption: 'Option hinzufügen',
        save: 'speichern',
        cancel: 'Abbrechen',
        uploadLogo: 'Logo hochladen',
        remove: 'Entfernen',
        paymentMethod: 'Zahlungsmethode',
        salePrice: 'Verkaufspreis',
        gender: 'Geschlecht',
        numberOfCourses: 'Anzahl der Kurse',
        coursesPurchased: 'Gekaufte Kurse',
        coursesCompleted: 'Abgeschlossene Kurse',
        quizCompleted: 'Quiz abgeschlossen',
        packagePurchaseCount: 'Anzahl der Paketkäufe',
        author: 'Autor',
        isFeatured: 'Empfohlen',
        numberOfCurriculums: 'Anzahl der Lehrpläne',
        numberOfContents: 'Anzahl der Inhalte',
        numberOfPurchases: 'Anzahl der Käufe',
        resetPassword: 'Passwort zurücksetzen',
        STUDENT: 'SCHÜLER',
        INSTRUCTOR: 'LEHRER',
        type: 'Art',
        uploadAvatar: 'Avatar hochladen',
        required: 'Erforderlich',
        uploadImage: 'Bild hochladen',
        resetAll: 'Alles zurücksetzen',
        path: 'Pfad',
        user: 'Benutzer',
        isPopular: 'Beliebt',
        free: 'Kostenlos',
        paid: 'Bezahlt',
        view: 'Aussicht',
        RememberMe:'Mich erinnern',
        ratings: 'Bewertungen',
        reviews:'Bewertungen',
        sortOrder: 'Sortierung',
        isRecordingOn: 'Aufnahme an',
        startDate: 'Anfangsdatum',
        endDate: 'Endtermin',
        upload: 'Hochladen',
        contents: 'Inhalt',
        uploadVideo: 'Video hochladen',
        uploadPDF: 'PDF hochladen',
        uploadDocument: 'Dokument hochladen',
        uploadSCORM: 'SCORM hochladen',
        uploadHTML: 'HTML hochladen',
        questions: 'Fragen',
        join: 'Beitreten',
        noResultFound: 'Keine Einträge gefunden',
        getThisCourse: 'Holen Sie sich diesen Kurs',
        actualPrice: 'Aktueller Preis',
        noContentAvailable: 'Kein Inhalt verfügbar',
        addedToTheCart: 'Zum Warenkorb hinzugefügt',
        checkout: 'Auschecken',
        totalPrice: 'Gesamtpreis',
        discount: 'Rabatt',
        total: 'Gesamt',
        pay: 'Zahlen',
        submit: 'einreichen',
        results: 'Ergebnisse',
        freeCoursesAllowedInPackages: 'Kostenlose Kurse in Paketen erlaubt',
        reviewParagraph1:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen Sylter Deich. Vogel Quax zwickt Johnys Pferd Bim. Sylvia wagt schnell den Jux bei Pforzheim. Polyfon zwitschernd aßen Mäxchens Vögel Rüben, Joghurt und Quark. "Repariere, Schwyz!" quäkt Jürgen blöd vom Paß. Victor jagt zwölf Boxkämpfer quer',
        uploadAvatar: 'Avatar hochladen',
        paragraph:'Diese Information zeigt die Identität des Administrators an',
        student_information:'Studenteninformationen',
        student_paragraph:'Diese Informationen zeigen die Identität des Administrators an',
        security:'Sicherheit',
        security_paragraph:'Diese Information zeigt die Identität des Administrators an',
        instructor_information:'Informationen des Lehrers',
        uploadBage:'Abzeichen hochladen',
        uploadParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        badgeInformation:'Abzeichen-Informationen',
        badgeInformationParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        uploadBanner:'Banner hochladen',
        uploadBannerParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        bannerInformation:'Banner-Informationen',
        bannerInformatioParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        levelInformation:'Level-Informationen',
        levelInformationParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        UploadImage:'Bild hochladen',
        UploadImageParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        CategoryInformation:'Informationen der Kategorie',
        CategoryInformationParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        selectCategory:'Kategorie wählen',
        selectCategoryParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        saveAndContinue:'Speichern und fortfahren',
        SelectCourseLevel:'Select Course Level',
        SelectCourseLevelParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigtKursniveau auswählen',
        UploadCourseThumbnail:'Kurs-Miniaturansicht hochladen',
        UploadCourseThumbnailParagraph:'Diese Informationen werden mit dem Logo der Organisation angezeigt',
        CourseInformation:'Kurs Information',
        CourseInformationParagraph:'Diese Informationen zeigen die Identität des Administrators an',
        CourseInstructor:'Kursleiter',
        Classification:'Einstufung',
        CoursePlane:'Kursplan',
        ModuleInformation:'Modulinformationen',
        AddModule:'Modul hinzufügen',
        Exit:'Ausfahrt',
        Module:'Module',
        addQuize:'Quiz hinzufügen',
        addContent:'Inhalt hinzufügen',
        contentInformation:'Inhaltsinformationen',
        AddContent:'Inhalt hinzufügen',
        QuizeQuestion:'Quizfragen',
        AddQuestions:'Fragen hinzufügen',
        NoContentYet:'Noch kein Inhalt!!',
        SaveCategoryandExit:'Kategorie speichern und beenden',
        addnewcategory:'neue Kategorie hinzufügen',
        SaveAsDraft:'Als Entwurf speichern',
        SearchCourse:'Kurs suchen',
        EnterCourseTitle:'Kurstitel eingeben',
        AddCourse:'Kurs hinzufügen',
         Step1:'SCHRITT 1',
         Step2:'SCHRITT 2',
         Step3:'SCHRITT 3',
         Step4:'SCHRITT 4',
        SelectCreateACategory:'KATEGORIE AUSWÄHLEN / ERSTELLEN',
        Select_SelectLevel:'WÄHLEN / LEVEL WÄHLEN',
        CreateCourse:'KURS ERSTELLEN',
        Add_Content:'INHALT HINZUFÜGEN',
        Or:'Oder',
        Module:'Modul',
        Featured: 'Hervorgehoben',
        Title:'Titel',
        Content:'Inhalt',
        Quiz:'Quiz',
        AddStudent:'Schüler hinzufügen',
        AddInstructor:'Lehrer hinzufügen',
        AddBages:'Abzeichen hinzufügen',
        AddBanner:'Banner hinzufügen',
        Category:'Kategorie hinzufügen',
        AddLevel:'Ebene hinzufügen',
        ViewDetail:'Im Detail sehen',
        Module:'Modul',
        h:'H',
        Browsecoursebycategory:'Kurs nach Kategorie durchsuchen',
        VideoQuiz:'Video-Quiz',
        showQuestion:'Fragen anzeigen',
        Enrolled:'Eingeschrieben',
        Assignment:'Abtretung',
        trainingSchedule: 'Trainingsplan',
        Lectures:'Vorlesungen',
        Module:'Modul',
        CirclumEdit:'Lehrplan.bearbeiten',
        Go:'Gehen',
        start:'Start',
        Find_Your_Course:'Finden Sie Ihren Kurs',
        curriculum:'Lehrplan',
        curriculumParagraph:'Eine qualitativ hochwertige Bildung hat die Kraft, die Welt zu verändern. Wählen Sie uns für eine bessere Zukunft.',
        Explore:'Erkunden',
       Home:'Heim',
       Footer:'© 2023 Railtel Education Inc., Alle Rechte vorbehalten',
       MyCourse:'Mein Kurs',
       Reviews:'Bewertungen',
       MyBadges:'Meine Abzeichen',
       YourProfile:'Dein Profil',
       EmailAddress:'E-Mail-Addresse',
       PhoneNumber:'Telefonnummer',
       Gender:'Geschlecht',
       EnrolledCourse:'Eingeschriebener Kurs',
       GraduatedIn:'Abgeschlossen',
       Badge:'Abzeichen',
       Information:'Information',
       Edit:'Bearbeiten',
       editProfile:'Profil bearbeiten',
       CreatedOn:'Erstellt am',
       myCourse: 'Mein Kurs',
       delete:'Löschen',
       Lession:'Lektion',
       YourReviews:'Ihre Bewertungen',
       MoreDetail:'Mehr Einzelheiten',
       AboutThisCourse:'Um Das Kurs',
       Instructor:'Lehrer',
       CourseCompletion:'Kurs Fertigstellung',
       Completed:'Vollendet',
       YourBadge:'Dein Abzeichen',
       course:'Kurs',
       COURSE:'KURS',
       CourseName:'Kursname',
       StudentName:'Studentin Name',
       ReviewDate:'Prüfungsdatum',
       AddIn:'Hinzugefügt',
       InstructorName:'Lehrername',
       Badge:'Abzeichen',
       NoOfCourse:'Nein, natürlich',
       SearchCategory:'Kategorie suchen',
       SubCategory:'Unterkategorie',
       EnterCategoryName:'Geben Sie den Kategorienamen ein',
       TotalContent:'Gesamtinhalt',
       TotalContentInCourse:'Gesamtinhalt im Kurs',
       CompletedContent:'Abgeschlossener Inhalt',
       CompletedContentParagraph:'Gesamtzahl der abgeschlossenen Kursinhalte',
       CompletionPercentage:'Fertigstellungsprozentsatz',
       CompletionPercentageParagraph:'Fertigstellungsprozentsatz aller Inhalte',
       TotalQuiz:'Totales Quiz',
       TotalQuizParagraph:'Gesamtquiz im Kurs',
       CompletedQuiz:'Abgeschlossenes Quiz',
       CompletedQuizParagraph:'Gesamtzahl der abgeschlossenen Kurse des Kursquiz',
       CompletionPercentage:'Fertigstellungsprozentsatz',
       CompletionPercentage:'Fertigstellungsprozentsatz aller Quizes',
       QuizPerformance:'Quiz-Leistung',
       QuizTitle:'Quiz Titel',
       UserScore:'Benutzerbewertung',
       TotalScore:'Gesamtpunktzahl',
       ScorePercentage:'Ergebnisprozentsatz',
       CompletedContents:'Abgeschlossene Inhalte',
       ContentType:'Inhaltstyp',
       NoOfCourses:'Anzahl Kurse',
       ContactInfo:'Kontaktinformation',
       DateOfJoining:'Beitrittsdatum',
       CompletedCourses:'Abgeschlossene Kurse',
       video:'Video',
       Pdf:'pdf',
       Ppt:'ppt',
       Quiz:'Quiz',
       EnrolledStudents:'Eingeschriebene Studierende',
       CompletePercentage:'kompletter Prozentsatz',
       SubscribedAt:'Abonniert bei',
       CompletedAt:'Abgeschlossen um',
       dataTableSearch: 'Suchen',
       emptyTable: 'Keine Daten in der Tabelle verfügbar',
       Show:'Zeigen',
       entries:'Einträge',
       infoEmpty:'Zeigt 0 bis 0 von 0 Einträgen',
       Showing:'Anzeigen',
       first: "Erste",
        last:"Zuletzt",
        next:"Nächste",
        previous:"Vorherige",
        PermissionDenied:'Zugriff verweigert',
        QuestionTitle:'Titel der Frage',
        SeeQuestions:'Siehe Fragen',
        BrowseCourse:'Kurs durchsuchen',
        Overview:'Überblick',
        Benefits:'Vorteile',
        WhatOurStudentsaying:'Was unser Student sagt',
        Limitedtimeoffer:"Zeitlich befristetes Angebot",
        GloballyRecognised:'Weltweit anerkannt',
        GetCertified:'Zertifiziert werden',
        Clickstartwhenyouready:'Klicken Sie auf Start, wenn Sie bereit sind',
        ContinuetoVideo:'Weiter zum Video',
        yourScore: 'Ihr Ergebnis',
        Gobacktocourse:'Gehen Sie zurück zum Kurs',
        Gobacktocontentlist:'Gehen Sie zurück zur Inhaltsliste',
        ViewAdd:'Anzeigen/Hinzufügen',
        Active:'Aktiv',
        AllCourses:'Alle Kurse',
        reviewParagraph:'Dies ist der Titel der Bewertung. Es wird hier angezeigt und der Inhalt unten ist die Bewertung',
        clickedCourses: 'Angeklickte Kurse',
        userClicked: 'Benutzer hat geklickt',
        CourseClickCount: 'Klicken Sie auf Zählen',
        loggedinUser: 'Angemeldeter Benutzer',
        guestUser: 'Gastbenutzer',
        courseClicked: 'Kurs angeklickt',
        instructorRatings: 'Lehrerbewertungen',
        InsRatingsReviews: 'Bewertungen/Rezensionen',
        Course: 'Kurs',
        yourReviews: 'Ihre Bewertungen',
        student: 'Studentin',
        wrongQuestionReport: 'Falscher Fragenbericht',
        question: 'Frage',
        module:'Modul',
        wrongMarked: 'Falsch markiert',
        updatedAt: 'Aktualisiert am',
      },
      adminInsRating: {
        userName: 'Nutzername',
        insName: 'Name des Kursleiters',
        rating: 'Bewertung',
        review: 'Rezension',
        status: 'Status',
        createdAt: 'Hergestellt in',
      },
      name: {
        label: 'Name',
        required: 'Name erforderlich',
      },
      description: {
        label: 'Beschreibung',
        required: 'Beschreibung Erforderlich',
      },
      image: {
        label: 'Bild',
        required: 'Bild erforderlich',
      },
      active: {
        label: 'Aktiv',
        required: 'Aktiv Erforderlich',
      },
      title:{
        label: 'Titel',
        required: 'Titel Erforderlich',
      },
      questions:{
        label: 'Frage',
        required: 'Frage erforderlich',
      },
      shortDescription: {
        label: 'kurze Beschreibung',
        required: 'Kurzbeschreibung Erforderlich',
      },
      student: {
        create: 'Schüler erstellen',
      },
      instructor:{
        create:'Lehrer erstellen'
      },
      benefits: {
        label: 'Leistungen',
        required: 'Benötigte Leistungen',
      },
      minLength20: {
        required: 'Mindestlänge 20 Erforderlich',
      },
      home: {
        registerBannerText: 'Schnell lernen, jetzt registrieren!',
        searchByCategory: 'Suche nach Kategorie',
        registerBannerDescription: `Top-Lehrer aus der ganzen Welt unterrichten Millionen von Schülern auf ${Parameters.clientName}. Melden Sie sich noch heute an und beginnen Sie mit dem Lernen.`,
        featuredCourses: 'Die beliebtesten Kurse',
        popularCourses: 'Beliebte Kurse',
        coursesByTopCategories: 'Die weltweit größte Auswahl an Kursen',
        coursesByTopCategoriesDescription: 'Wählen Sie aus 155.000 Online-Videokursen mit monatlichen Neuzugängen',
        ourPlans: 'Unsere Pläne',
        ourTeachers: 'Treffen Sie die besten Lehrer',
        CourseContent:'Kursinhalt'
      },
      register: {
        connect: 'Registrieren',
        changePassword: 'Kennwort ändern',
        name: {
          label: 'Name',
          required: 'Name erforderlich',
        },
        email: {
          label: 'Email',
          required: 'Email erforderlich',
        },
        phone: {
          label: 'Telefon',
          required: 'Telefon erforderlich',
        },
        gender: {
          label: 'Geschlecht',
          required: 'Geschlecht erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
        password_confirmation: {
          label: 'Kennwort bestätigen',
          required: 'Passwort bestätigen erforderlich',
        },
      },
      resetPassword: {
        reset: 'Passwort zurücksetzen',
        email: {
          label: 'Email',
          required: 'Email erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
        password_confirmation: {
          label: 'Kennwort bestätigen',
          required: 'Passwort bestätigen erforderlich',
        },
      },
      organization: {
        // frontDomain: 'Front Domain',
        // hasBBB: 'Has BBB',
        homeTitle: {
          label: 'Startseite Titel'
        },
        homeDescription: {
          label: 'Startseite Beschreibung'
        },
        theme: {
          label: 'Thema'
        },
        create: 'Organisation erstellen',
        paypalCredentials: 'Paypal-Anmeldeinformationen',
        name: {
          label: 'Name',
          required: 'Name erforderlich',
        },
        email: {
          label: 'Email',
          required: 'Email erforderlich',
        },
        domain: {
          label: 'Domain',
          required: 'Domäne erforderlich',
        },
        frontDomain: {
          label: 'Front-Domain',
          required: 'Front-Domain erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
        password_confirmation: {
          label: 'Kennwort bestätigen',
          required: 'Passwort bestätigen erforderlich',
        },
        isClosed: {
          label: 'Geschlossen',
        },
        hasBBB: {
          label: 'Hat BBB',
        }
        ,
        description: {
          label: 'Beschreibung',
          required: 'Beschreibung Erforderlich',
        },
        image: {
          required: 'Organisationsbild erforderlich',
        },
      },
      courses: {
        purchaseCourseFirst: 'Kurs zuerst kaufen'
      },
      report: {
        order_status: 'Bestellstatus',
      },
      login: {
        connect: 'Anmeldung',
        email: {
          label: 'E-Mail-Addresse',
          required: 'Email erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
      },
      profile: {
        update: 'Aktualisieren',
        changePassword: 'Kennwort ändern',
        name: {
          label: 'Name',
          required: 'Name erforderlich',
        },
        email: {
          label: 'Email',
          required: 'Email erforderlich',
        },
        phone: {
          label: 'Telefon',
          required: 'Telefon erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
        password_confirmation: {
          label: 'Kennwort bestätigen',
          required: 'Passwort bestätigen erforderlich',
        },
        gender: {
          label:  "Geschlecht",
          required:"Geschlecht erforderlich",
        }
      },
      user: {
        type: {
          label: 'Art',
          required: 'Typ Erforderlich',
        },
        category: {
          label: 'Kategorie',
          required: 'Kategorie Erforderlich',
          placeholder: 'Bitte auswählen',
        },
        name: {
          label: 'Name',
          required: 'Name erforderlich',
        },
        email: {
          label: 'Email',
          required: 'Email erforderlich',
        },
        phone: {
          label: 'Telefon',
          required: 'Telefon erforderlich',
        },
        gender: {
          label: 'Geschlecht',
          required: 'Geschlecht erforderlich',
        },
        jobTitle: {
          label: 'Berufsbezeichnung',
          required: 'Berufsbezeichnung erforderlich',
        },
        aboutMe: {
          label: 'Über mich',
          required: 'Über mich Erforderlich',
        },
        password: {
          label: 'Passwort',
          required: 'Passwort erforderlich',
          minLength6: 'Mindestens 6 Zeichen erforderlich',
          unmatched: 'Passwort nicht abgeglichen',
        },
        password_confirmation: {
          label: 'Kennwort bestätigen',
          required: 'Passwort bestätigen erforderlich',
        },
        image: {
          label: 'Bild',
          required: 'Benutzerbild erforderlich',
        },
      },
      badge: {
        create: 'Abzeichen erstellen',
        numberOfCourses: {
          label: 'Anzahl der Kurse',
          required: 'Anzahl der erforderlichen Kurse',
        },
        edit:'Abzeichen bearbeiten',
        profile:'Abzeichen-Profil',
        image: {
          label: 'Bild',
          required: 'Abzeichenbild erforderlich',
        },
      },
      banner: {
        create: 'Banner erstellen',
        edit: 'banner.bearbeiten',
        profile:'Bannerprofil'
      },
      banners: {
        create: 'Banner erstellen',
      },
      // banner: {
      //   edit: 'banner.bearbeiten',
      // },
      package: {
        create: 'Paket erstellen',
        price: {
          label: 'Preis',
          required: 'Preis erforderlich',
        },
        salePrice: {
          label: 'Verkaufspreis',
          required: 'Verkaufspreis erforderlich',
        },
        numberOfCourses: {
          label: 'Anzahl der Kurse',
          required: 'Anzahl der erforderlichen Kurse',
        },
        validity: {
          label: 'Gültigkeit',
          required: 'Gültigkeit erforderlich',
        },
        validityInMonths: {
          label: 'Gültigkeit in Monaten',
          required: 'Gültigkeit erforderlich',
        },
        image: {
          label: 'Bild',
          required: 'Bannerbild erforderlich',
        },
      },
      category: {
        create: 'Kategorie erstellen',
        choose: 'Kategorie wählen',
      },
      page: {
        create: 'Seite erstellen',
        titleDe: {
          label: 'Titel In Deutsch',
          required: 'Titel erforderlich',
        },
        title: {
          label: 'Titel auf Englisch',
          required: 'Titel erforderlich',
        },
        descriptionDe: {
          label: 'Beschreibung In Deutsch',
          required: 'Beschreibung Erforderlich',
        },
        description: {
          label: 'Beschreibung auf Englisch',
          required: 'Beschreibung Erforderlich',
        },
        path: {
          label: 'Pfad',
          required: 'Pfad erforderlich',
        },
        type: {
          label: 'Art',
          required: 'Typ Erforderlich',
        },
        numberOfCourses: {
          label: 'Anzahl der Kurse',
          required: 'Anzahl der erforderlichen Kurse',
        },

        image: {
          label: 'Bild',
          required: 'Abzeichenbild erforderlich',
        },
      },
      level: {
        create: 'Level erstellen',
        choose: 'Wählen Sie Ebene',
      },
      course: {
        create: 'Kurs erstellen',
        addedToFavSuccessfully: 'Erfolgreich zu Favoriten hinzugefügt',
        removedFromFavSuccessfully: 'Erfolgreich aus Favoriten entfernt',
        linkCopiedSuccessFully: 'Link erfolgreich kopiert',
        failed: 'Gescheitert',
        average: 'Durchschnittlich',
        good: 'Gut',
        excellent: 'Ausgezeichnet',
        yourScore: 'Ihre Punktzahl',
        totalScore: 'Gesamtpunktzahl',
        percentage: 'Prozentsatz',
        response: 'Antwort',
        plan: {
          label: 'Planen',
          required: 'Plan erforderlich',
        },
        instructor: {
          label: 'Lehrer',
          required: 'Ausbilder erforderlich',
        },
        level: {
          label: 'Niveau',
          required: 'Erforderliches Niveau',
        },
        category: {
          label: 'Kategorie',
          required: 'Kategorie erforderlich',
        },
        isFeatured: {
          label: 'Empfohlen',
          required: 'Empfohlen erforderlich',
        },
        isPopular: {
          label: 'Beliebt',
          required: 'Beliebt Erforderlich',
        },
        price: {
          label: 'Preis',
          required: 'Preis erforderlich',
        },
        salePrice: {
          label: 'Verkaufspreis',
          required: 'Verkaufspreis erforderlich',
          lessThanPrice: 'Der Verkaufspreis sollte niedriger sein als der Preis',
        },
        image: {
          label: 'Bild',
          required: 'Kursbild erforderlich',
        },
      },
      meeting: {
        create: 'Besprechung erstellen',
        titleDe: {
          label: 'Titel In Deutsch',
          required: 'Titel erforderlich',
        },
        title: {
          label: 'Titel auf Englisch',
          required: 'Titel erforderlich',
        },
        descriptionDe: {
          label: 'Beschreibung In Deutsch',
          required: 'Beschreibung Erforderlich',
        },
        description: {
          label: 'Beschreibung auf Englisch',
          required: 'Beschreibung Erforderlich',
        },
        isRecordingOn: {
          label: 'Aufnahme an',
          required: 'Aufnahme ein erforderlich',
        },
        startDate: {
          label: 'Anfangsdatum',
          required: 'Startdatum erforderlich',
          shouldBeGreaterThanToday: 'Startdatum sollte größer sein als heute',
        },
        endDate: {
          label: 'Endtermin',
          required: 'Enddatum erforderlich',
        },

        image: {
          label: 'Bild',
          required: 'Besprechungsbild erforderlich',
        },
      },
      curriculum: {
        create: 'Lehrplan erstellen',
        edit:'edit.curriculum',
        titleDe: {
          label: 'Titel In Deutsch',
          required: 'Titel erforderlich',
        },
        title: {
          label: 'Titel auf Englisch',
          required: 'Titel erforderlich',
        },
        descriptionDe: {
          label: 'Beschreibung In Deutsch',
          required: 'Beschreibung Erforderlich',
        },
        description: {
          label: 'Beschreibung auf Englisch',
          required: 'Beschreibung Erforderlich',
        },
        isRecordingOn: {
          label: 'Aufnahme an',
          required: 'Aufnahme ein erforderlich',
        },
        sortOrder: {
          label: 'Sortierung',
          required: 'Sortierreihenfolge erforderlich',
        },
        image: {
          label: 'Bild',
          required: 'Lehrplanbild erforderlich',
        },
      },
      content: {
        create: 'Inhalte erstellen',
        assignment: 'Zuordnung',
        scorm: 'Scorm',
        quiz: 'Quiz',
        html: 'HTML',
        external_url: 'Externe URL',
        youtube_url: 'YouTube-URL',
        titleDe: {
          label: 'Titel In Deutsch',
          required: 'Titel erforderlich',
        },
        title: {
          label: 'Titel auf Englisch',
          required: 'Titel erforderlich',
        },
        descriptionDe: {
          label: 'Beschreibung In Deutsch',
          required: 'Beschreibung Erforderlich',
          minLength20: 'Mindestens 20 Zeichen erforderlich',
        },
        description: {
          label: 'Beschreibung auf Englisch',
          required: 'Beschreibung Erforderlich',
          minLength20: 'Mindestens 20 Zeichen erforderlich',
        },
        isPreview: {
          label: 'Vorschau',
          required: 'Vorschau erforderlich',
        },
        type: {
          label: 'Art',
          required: 'Typ Erforderlich',
        },
        sortOrder: {
          label: 'Sortierung',
          required: 'Sortierreihenfolge erforderlich',
        },
        lectureType: {
          label: 'Vortragsart',
          required: 'Vorlesungstyp erforderlich',
        },
        lecture: {
          label: 'Vorlesung',
          video_id: 'Video-ID',
          vimeo_url: 'Vimeo URL',
          external_url: 'Externe URL',
          youtube_url: 'YouTube-URL',
        },
        generalInstructions: {
          label: 'Allgemeine Anweisungen',
          required: 'Allgemeine Anweisungen erforderlich',
          minLength20: 'Mindestens 20 Zeichen erforderlich',
        },
        image: {
          label: 'Bild',
          required: 'Inhaltsbild erforderlich',
        },
      },
      question: {
        create: 'Fragen erstellen',
        singleSelect: 'Einzelauswahl',
        multiSelect: 'Mehrfachauswahl',
        numeric: 'Numerisch',
        titleDe: {
          label: 'Titel In Deutsch',
          required: 'Titel erforderlich',
        },
        title: {
          label: 'Titel auf Englisch',
          required: 'Titel erforderlich',
        },
        descriptionDe: {
          label: 'Beschreibung In Deutsch',
          required: 'Beschreibung Erforderlich',
        },
        description: {
          label: 'Beschreibung auf Englisch',
          required: 'Beschreibung Erforderlich',
        },
        type: {
          label: 'Art',
          required: 'Typ Erforderlich',
        },
        positiveMarks: {
          label: 'Positive Noten',
          required: 'Positive Noten erforderlich',
        },
        negativeMarks: {
          label: 'Negative Noten',
          required: 'Negative Noten erforderlich',
        },
        option: {
          isCorrect: {
            label: 'Ist Korrekturoption',
          },
          title: {
            label: 'Titel',
            required: 'Titel Erforderlich',
          },
        },
        image: {
          label: 'Bild',
          required: 'Fragebild erforderlich',
        },
      },
      review: {
        label: 'Rezension',
        required: 'Überprüfung erforderlich',
      },
      rating: {
        label: 'Bewertung',
        required: 'Bewertung erforderlich',
      },
    },
  },
  ar: {
    translation: {
      genDict: {
        addedToTheCard: 'تمت إضافة العنصر إلى عربة التسوق',
        WhoBroughtInstructor : 'طالب الدورة',
        organization: 'منظمة',
        certificate: 'شهادة',
        applyNow: 'قدم الآن',
        SubCategory:'تصنيف فرعي',
        Paragraph3:'تعلم مهارات جديدة وحقق نموًا أعلى في حياتك المهنية',
        Paragraph2:'Dolor sit amet consectetur adipiscing النخبة pellentesque المعيشية morbi. معرف interdum velit laoreet id donec ultrices. فرينجيلا فاسيلوس فوسيبوس سكليرسك إلييفند دونك بريتيوم. Est pellentesque النخبة ullamcorper كريم. Mauris ultrices إيروس في cursus turpis ماسا tincidunt dui.',
        IntroductionOfGraphicDesign:'مقدمة في التصميم الجرافيكي',
        DiplomaInWebDevelopment:'دبلوم في تطوير الويب',
        GloballyRecognised:'معترف بها عالميا',
        ContentReportsOf:'تقارير محتوى',
        CreateBanner:'إنشاء لافتة',
        ADMIN: 'مسؤل',
        IntermediateInWebDevelopment:'متوسط ​​في تطوير الويب',
        Orange:'البرتقالي',
        GetCertified:'الحصول على شهادة',
        Startlearning:'ابدا بالتعلم',
        DigitalMarketing:'التسويق الرقمي',
        PurchaseDate:'تاريخ الشراء',
        Green:'أخضر',
        MarketingParagraph:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. فرانز جاغت إيم كامل فيروهارلوستن تاكسي quer durch بايرن ميونيخ. Zwölf Boxkämpfer jagen Viktor quer über den großen. فرانز جاغت إيم كامل فيروهارلوستن تاكسي quer durch بايرن ميونيخ. Zwölf Boxkämpfer jagen Viktor quer über den großen',
        GraphicDesign:'التصميم الجرافيكي',
        Red:'أحمر',
        LessionParagraph:'لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. لوريم إيبسوم هو ببساطة نص شكلي في صناعة الطباعة والتنضيد. لوريم إيبسوم هو ببساطة نص شكلي في صناعة الطباعة والتنضيد. لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد',
        Graduated:'تخرج',
        SellingPrice:'سعر البيع',
        Message:'رسالة',
        BrowseCourse:'تصفح الدورة',
        Default:'تقصير',
        Writeareview:'أكتب مراجعة',
        Read:'يقرأ',
        descriptionParagraph: 'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. فرانز',
        ScheduleDate:'تاريخ الجدول الزمني',
        Watch:'يشاهد',
        BacklogNumber:'رقم السجل',
        TeachingCourse:'دورة تعليمية',
        ForgotPassword:'هل نسيت كلمة السر؟',
        courses: 'الدورات',
        RememberMe:'تذكرنى',
        loginNeeded: 'تسجيل الدخول مطلوب',
        levels: 'المستويات',
        // banners: 'لافتات',
        banners:'إنشاء لافتة',
        AnishaParveen:'أنيشا بارفين',
        badges: 'شارات',
        users: 'المستخدمون',
        admins: 'المشرفون',
        students: 'طلاب',
        instructors: 'المدربين',
        admin: 'مسؤل',
        content: 'محتوى',
        packages: 'الحزم',
        staticPages: 'صفحات ثابتة',
        ordersReport: 'تقرير الطلبات',
        reports: 'التقارير',
        instructorsReport: 'تقرير المدربين',
        learnersReport: 'تقرير المتعلمين',
        studentsReport: 'تقرير الطلاب',
        coursesReport: 'تقرير الدورات',
        createdAt: 'أنشئت في',
        by: 'بواسطة',
        login: 'تسجيل الدخول',
        select: 'يختار',
        male: 'ذكر',
        female: 'أنثى',
        status: 'حالة',
        payment_method: 'طريقة الدفع او السداد',
        email: 'بريد إلكتروني',
        phone: 'هاتف',
        transactionId: 'رقم المعاملة',
        createdDate: 'أنشئت في',
        items: 'أغراض',
        course: 'دورة',
        review: 'مراجعة',
        rating: 'تقييم',
        minutes: 'دقيقة',
        filter: 'منقي',
        category: 'فئة',
        level: 'مستوى',
        plan: 'يخطط',
        skillLevel: 'مستوى المهارة',
        viewCourse: 'عرض الدورة',
        description: 'وصف',
        duration: 'مدة',
        lectures: 'محاضرات',
        resources: 'موارد',
        search: 'يبحث',
        curriculums: 'المناهج',
        curriculum: 'مقرر',
        reviews: 'المراجعات',
        preview: 'معاينة',
        explore: 'يستكشف',
        register: 'يسجل',
        applyNow: 'قدم الآن',
        connect: 'تسجيل الدخول',
        exploreCourses: 'اكتشف الدورات',
        image: 'صورة',
        title: 'عنوان',
        price: 'سعر',
        action: 'فعل',
        profile: 'حساب تعريفي',
        orders: 'طلبات',
        calender: 'تقويم',
        myReviews: 'ملاحظاتي',
        logout: 'تسجيل خروج',
        meetings: 'الاجتماعات',
        myCourses: 'دوراتي',
        categories: 'فئات',
        changePassword: 'تغيير كلمة المرور',
        updateProfile: 'تحديث الملف',
        copyRight: 'حقوق النشر',
        about: 'عن',
        contact: 'اتصال',
        termsOfUse: 'شروط الاستخدام',
        privacyPolicy: 'سياسة الخصوصية',
        name: 'اسم',
        domain: 'اِختِصاص',
        confirmDelete: 'تأكيد الحذف',
        isClosed: 'مغلق',
        ok: 'نعم',
        cancel: 'يلغي',
        success: 'نجاح',
        organizations: 'المنظمات',
        add: 'يضيف',
        addOption: 'إضافة خيار',
        save: 'يحفظ',
        cancel: 'يلغي',
        Featured: 'متميز',
        uploadLogo: 'تحميل الشعار',
        remove: 'يزيل',
        paymentMethod: 'طريقة الدفع او السداد',
        salePrice: 'سعر البيع',
        gender: 'جنس',
        numberOfCourses: 'عدد الدورات',
        coursesPurchased: 'الدورات المشتراة',
        coursesCompleted: 'الدورات المنجزة',
        quizCompleted: 'اكتمل الاختبار',
        packagePurchaseCount: 'عدد شراء الحزمة',
        author: 'مؤلف',
        isFeatured: 'متميز',
        numberOfCurriculums: 'عدد المناهج',
        numberOfContents: 'عدد المحتويات',
        numberOfPurchases: 'عدد المشتريات',
        resetPassword: 'إعادة تعيين كلمة المرور',
        STUDENT: 'طالب',
        INSTRUCTOR: 'مدرب',
        type: 'يكتب',
        uploadAvatar: 'تحميل الصورة الرمزية',
        required: 'مطلوب',
        uploadImage: 'تحميل الصور',
        resetAll: 'إعادة ضبط الجميع',
        path: 'طريق',
        user: 'مستخدم',
        isPopular: 'شائع',
        free: 'حر',
        paid: 'مدفوع',
        view: 'منظر',
        ratings: 'التقييمات',
        reviews:'المراجعات',
        sortOrder: 'امر ترتيب',
        isRecordingOn: 'التسجيل قيد التشغيل',
        startDate: 'تاريخ البدء',
        endDate: 'تاريخ الانتهاء',
        upload: 'رفع',
        contents: 'محتويات',
        uploadVideo: 'رفع فيديو',
        uploadPDF: 'تحميل ملف بي دي إف',
        uploadDocument: 'تحميل المستند',
        uploadSCORM: 'تحميل SCORM',
        uploadHTML: 'تحميل لغة البرمجة',
        questions: 'أسئلة',
        join: 'ينضم',
        noResultFound: 'لم يتم العثور على نتائج',
        getThisCourse: 'احصل على هذه الدورة',
        actualPrice: 'السعر الفعلي',
        noContentAvailable: 'لا يوجد محتوى متاح',
        addedToTheCart: 'يضاف إلى عربة التسوق',
        checkout: 'الدفع',
        totalPrice: 'السعر الكلي',
        discount: 'تخفيض',
        total: 'المجموع',
        pay: 'يدفع',
        MoreDetail:'المزيد من التفاصيل',
        submit: 'يُقدِّم',
        Lession:'إجازة',
        results: 'نتائج',
        freeCoursesAllowedInPackages: 'الدورات المجانية المسموح بها في الحزم',
        getPlan: 'احصل على خطة',
        uploadAvtar: 'تحميل الصورة الرمزية',
        paragraph:'ستعرض هذه المعلومات تعريف المسؤول',
        student_information:'معلومات الطالب',
        student_paragraph:'ستعرض هذه المعلومات تعريف المسؤول',
        security:'حماية',
        security_paragraph:'ستعرض هذه المعلومات تعريف المسؤول',
        instructor_information:'المعلم_المعلومات',
        uploadBage:'تحميل شارة',
        uploadParagraph:'سيتم عرض هذه المعلومات شعار المنظمة',
        badgeInformation:'معلومات الشارة',
        badgeInformationParagraph:'سيتم عرض هذه المعلومات شعار المنظمة',
        uploadBanner:'تحميل لافتة',
        uploadBannerParagraph:'سيتم عرض هذه المعلومات شعار المنظمة',
        bannerInformation:'راية المعلومات',
        bannerInformatioParagraph:'سيتم عرض هذه المعلومات شعار المنظمة',
        levelInformation:'مستوى المعلومات',
        levelInformationParagraph:'ستعرض هذه المعلومات تعريف المسؤول',
        UploadImage:'تحميل الصور',
        UploadImageParagraph:'ستعرض هذه المعلومات تعريف المسؤول',
        CategoryInformation:'معلومات الفئة',
        CategoryInformationParagraph:'ستعرض هذه المعلومات تعريف المسؤول',
        selectCategory:'زمرہ منتخب کریں۔',
        selectCategoryParagraph:'یہ معلومات ایڈمنسٹریٹر کی شناخت ظاہر کرے گی۔',
        saveAndContinue:'محفوظ کریں اور جاری رکھیں',
        SelectCourseLevel:'کورس کی سطح کو منتخب کریں۔',
        SelectCourseLevelParagraph:'یہ معلومات ایڈمنسٹریٹر کی شناخت ظاہر کرے گی۔',
        UploadCourseThumbnail:'کورس تھمب نیل اپ لوڈ کریں۔',
        UploadCourseThumbnailParagraph:'یہ معلومات تنظیم کے لوگو کو ظاہر کرے گی۔',
        CourseInformation:'کورس کی معلومات',
        CourseInformationParagraph:'یہ معلومات منتظم کی شناخت ظاہر کی جائے گی۔',
        CourseInstructor:'کورس انسٹرکٹر',
        reviewParagraph:'هذا عنوان المراجعة. سيتم عرضه هنا والمحتوى أدناه هو المراجعة',
        Classification:'درجہ بندی',
        CoursePlane:'کورس پلان',
        ModuleInformation:'ماڈیول کی معلومات',
        AddModule:'ماڈیول شامل کریں۔',
        Exit:'مخرج',
        Module:'وحدة',
        addQuize:'أضف مسابقة',
        addContent:'إضافة محتوى',
        contentInformation:'معلومات المحتوى',
        AddContent:'إضافة محتوى',
        QuizeQuestion:'کوئز سوالات',
        AddQuestions:'سوالات شامل کریں۔',
        NoContentYet:'ابھی تک کوئی مواد نہیں !!',
        SaveCategoryandExit:'زمرہ محفوظ کریں اور باہر نکلیں۔',
        addnewcategory:'نیا زمرہ شامل کریں۔',
        SaveAsDraft:'ڈرافٹ کے طور پر محفوظ کریں۔',
        SearchCourse:'تلاش کورس',
        EnterCourseTitle:'کورس کا عنوان درج کریں۔',
        AddCourse:'کورس شامل کریں۔',
        Step1:'مرحلہ نمبر 1',
        Step2:'مرحلہ نمبر 2',
        Step3:'مرحلہ نمبر 3',
        Step4:'مرحلہ نمبر 4',
        SelectCreateACategory:'ایک زمرہ منتخب کریں / بنائیں',
        Select_SelectLevel:'منتخب کریں / منتخب کریں سطح',
        CreateCourse:'کورس بنائیں',
        Add_Content:'مواد شامل کریں۔',
        Or:'یا',
        Module:'ماڈیول',
        Title:'عنوان',
        Content:'مواد',
        Quiz:'کوئز',
        AddStudent:'طالب علم شامل کریں۔',
        AddInstructor:'اضافة مدرس',
        AddBages:'بیج شامل کریں۔',
        AddBanner:'بینر شامل کریں۔',
        Category:'زمرہ شامل کریں۔',
        AddLevel:'لیول شامل کریں۔',
        ViewDetail:'تفصیل دیکھیں',
        Module:'ماڈیول',
        h:'ح',
        VideoQuiz:'ویڈیو کوئز',
        showQuestion:'سوالات دکھائیں۔',
        Enrolled:'اندراج',
        Assignment:'تكليف',
        trainingSchedule: 'جدول التدريب',
        Lectures:'لیکچرز',
        Module:'وحدة',
        CirclumEdit:'نصاب.ترمیم',
        Go:'يذهب',
        Find_Your_Course:'ابحث عن دورتك',
        curriculum:'مقرر',
        curriculumParagraph:'التعليم الجيد لديه القدرة على تغيير العالم. اختر لنا من أجل مستقبل أفضل.',
        Explore:'يستكشف',
        reviewParagraph1:'Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. فرانز جاغت إيم كامل فيروهارلوستن تاكسي من دورش بايرن. Zwölf Boxkämpfer jagen Viktor quer über den großen Sylter Deich. فوجل كواكس زويكت جونيس بفرد بيم. سيلفيا فاغت كويك دن جوكس باي بفورتسهايم. Polyfon zwitschernd aßen Mäxchens Vögel Rüben، Joghurt und Quark. "الإصلاح ، شفيتس!" quäkt Jürgen blöd vom Paß. فيكتور جاغت زفولف Boxkämpfer quer',
        Home:'بيت',
        Footer:'© 2023 رايلتل تعليم شركة.، كل الحقوق محفوظة',
        MyCourse:'مقرري',
       Reviews:'المراجعات',
       MyBadges:'شاراتي',
       YourProfile:'ملفك الشخصي',
       EmailAddress:'عنوان البريد الإلكتروني',
       PhoneNumber:'رقم التليفون',
       EnrolledCourse:'دورة مسجلة',
       GraduatedIn:'تخرجت في',
       Badge:'شارة',
       Information:'معلومة',
       Edit:'يحرر',
       editProfile:'تعديل الملف الشخصي',
       CreatedOn:'تم إنشاؤها على',
       myCourse: 'مقرري',
       delete:'يمسح',
       YourReviews:'تعليقاتك',
       MoreDetail:'المزيد من التفاصيل',
       AboutThisCourse:'حول هذه الدورة',
       Instructor:'مدرب',
       CourseCompletion:'إتمام الدورة',
       Completed:'مكتمل',
       YourBadge:'شارتك',
       COURSE:'دورة',
       Popular: 'شائع',
       CourseName:'اسم الدورة التدريبية',
       StudentName:'أسم الطالب',
       ReviewDate:'تاريخ المراجعة',
       AddIn:'أضيفت في',
       InstructorName:'اسم المدرب',
       Badge:'شارة',
       NoOfCourse:'رقم بالطبع',
       SearchCategory:'فئة البحث',
       SubCategory:'تصنيف فرعي',
       EnterCategoryName:'أدخل اسم الفئة',
       TotalContent:'إجمالي المحتوى',
       TotalContentInCourse:'إجمالي المحتوى في الدورة',
       CompletedContent:'المحتوى المكتمل',
       CompletedContentParagraph:'إجمالي العدد المكتمل لمحتوى الدورة',
       CompletionPercentage:'نسبة الإنجاز',
       CompletionPercentageParagraph:'نسبة الإنجاز لجميع المحتويات',
       TotalQuiz:'مجموع المسابقة',
       TotalQuizParagraph:'مجموع الاختبار في الدورة',
       CompletedQuiz:'اكتمل الاختبار',
       CompletedQuizParagraph:'إجمالي العد المكتمل لمسابقة الدورة التدريبية',
       CompletionPercentage:'نسبة الإنجاز',
       CompletionPercentageParagraph:'نسبة الإنجاز لجميع المسابقات',
       QuizPerformance:'أداء الاختبار',
       QuizTitle:'عنوان الإختبار',
       UserScore:'نقاط المستخدم',
       TotalScore:'مجموع النقاط',
       ScorePercentage:'نسبة النتيجة',
       CompletedContents:'المحتويات المكتملة',
       ContentType:'نوع المحتوى',
       NoOfCourses:'عدد الدورات',
       ContactInfo:'معلومات الاتصال',
       DateOfJoining:'تاريخ الانضمام',
       CompletedCourses:'الدورات المكتملة',
       CourseContent:'محتوى الدورة',
       video:'فيديو',
       Pdf:'بي دي إف',
       Ppt:'جزء لكل تريليون',
       Quiz:'اختبار',
       EnrolledStudents:'الطلاب المسجلين',
       CompletePercentage:'النسبة المئوية الكاملة',
       SubscribedAt:'مشترك في',
       CompletedAt:'اكتمل في',
       dataTableSearch: 'يبحث',
       emptyTable: 'لا توجد بيانات متوفرة في الجدول',
       Show:'يعرض',
       entries:'إدخالات',
       infoEmpty:'إظهار 0 إلى 0 من 0 مدخلات',
       Showing:'عرض',
       first: "أولاً",
        last:"آخر",
        next:"التالي",
        previous:"سابق",
        PermissionDenied:'تم رفض الإذن',
        QuestionTitle:'عنوان السؤال',
        SeeQuestions:'انظر الأسئلة',
        BrowseCourse:'تصفح الدورة',
        Overview:'ملخص',
        Benefits:'فوائد',
        WhatOurStudentsaying:'ماذا يقول طالبنا',
        Limitedtimeoffer:"عرض لوقت محدود",
        GloballyRecognised:'معترف بها عالميا',
        GetCertified:'الحصول على شهادة',
        Clickstartwhenyouready:'انقر فوق ابدأ عندما تكون جاهزًا',
        ContinuetoVideo:'تابع إلى الفيديو',
        yourScore: 'درجاتك',
        start:'يبدأ',
        Gobacktocourse:'ارجع إلى المسار',
        Gobacktocontentlist:'العودة إلى قائمة المحتوى',
        ViewAdd:'عرض / إضافة',
        Active:'نشيط',
        AllCourses:'جميع الدورات',
        Browsecoursebycategory:'تصفح الدورة حسب الفئة',
        clickedCourses: 'الدورات التي تم النقر عليها',
        userClicked: 'نقر المستخدم',
        CourseClickCount: 'انقر فوق عدد',
        loggedinUser: 'مستخدم قام بتسجيل الدخول',
        guestUser: 'حساب زائر',
        courseClicked: 'تم النقر فوق الدورة',
        instructorRatings: 'تقييمات المعلم',
        InsRatingsReviews: 'التقييمات / التعليقات',
        Course: 'دورة',
        yourReviews: 'تعليقاتك',
        student: 'طالب',
        wrongQuestionReport: 'تقرير سؤال خاطئ',
        question: 'سؤال',
        module:'وحدة',
        wrongMarked: 'تم وضع علامة خاطئة',
        updatedAt: 'تم التحديث في',
      },
      adminInsRating: {
        userName: 'اسم المستخدم',
        insName: 'اسم المدرب',
        rating: 'تقييم',
        review: 'مراجعة',
        status: 'حالة',
        createdAt: 'أنشئت في',
      },
      name: {
        label: 'اسم',
        required: 'الاسم مطلوب',
      },
      description: {
        label: 'وصف',
        required: 'الوصف مطلوب',
      },
      image: {
        label: 'صورة',
        required: 'الصورة مطلوبة',
      },
      student: {
        create: 'خلق الطالب',
      },
      instructor:{
        create:'إنشاء المعلم'
      },
      active: {
        label: 'نشيط',
        required: 'نشط مطلوب',
      },
      title: {
        label: 'عنوان',
        required: 'عنوان مطلوبة',
      },
      questions:{
        label: 'سؤال',
        required: 'السؤال مطلوب',
      },
      shortDescription: {
        label: 'وصف قصير',
        required: 'مطلوب وصف قصير',
      },
      benefits: {
        label: 'فوائد',
        required: 'الفوائد المطلوبة',
      },
      minLength20: {
        required: 'يجب ألا يقل الطول عن 20',
      },
      home: {
        registerBannerText: 'ابدأ التعلم السريع ، سجل الآن!',
        searchByCategory: 'البحث بالفئة',
        registerBannerDescription: `يقوم كبار المدرسين من جميع أنحاء العالم بتدريس ملايين الطلاب على $ {Parameters.clientName}. سجل اليوم وابدأ التعلم.`,
        featuredCourses: 'أهم الدورات التدريبية',
        popularCourses: 'الدورات الشعبية',
        coursesByTopCategories: 'أكبر مجموعة من الدورات التدريبية في العالم \ ن',
        coursesByTopCategoriesDescription: 'اختر من بين 155000 دورة فيديو عبر الإنترنت مع إضافات جديدة تُنشر كل شهر',
        ourPlans: 'خططنا',
        ourTeachers: 'تعرف على أفضل المعلمين',
      },
      register: {
        connect: 'يسجل',
        changePassword: 'تغيير كلمة المرور',
        name: {
          label: 'اسم',
          required: 'الاسم مطلوب',
        },
        email: {
          label: 'بريد إلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        phone: {
          label: 'هاتف',
          required: 'الهاتف مطلوب',
        },
        gender: {
          label: 'جنس',
          required: 'جنس مطلوبة',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
        password_confirmation: {
          label: 'تأكيد كلمة المرور',
          required: 'مطلوب تأكيد كلمة المرور',
        },
      },
      resetPassword: {
        reset: 'إعادة تعيين كلمة المرور',
        email: {
          label: 'بريد إلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
        password_confirmation: {
          label: 'تأكيد كلمة المرور',
          required: 'مطلوب تأكيد كلمة المرور',
        },
      },
      organization: {
        // frontDomain: 'المجال الأمامي',
        // hasBBB: 'لديه BBB',
        create: 'إنشاء المنظمة',
        paypalCredentials: 'أوراق اعتماد Paypal',
        name: {
          label: 'اسم',
          required: 'الاسم مطلوب',
        },
        theme: {
          label: 'سمة'
        },
        homeTitle: {
          label: 'عنوان المنزل'
        },
        homeDescription: {
          label: 'وصف المنزل'
        },
        email: {
          label: 'بريد إلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        domain: {
          label: 'اِختِصاص',
          required: 'المجال مطلوب',
        },
        frontDomain: {
          label: 'المجال الأمامي',
          required: 'المجال الأمامي مطلوب',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
        password_confirmation: {
          label: 'تأكيد كلمة المرور',
          required: 'مطلوب تأكيد كلمة المرور',
        },
        isClosed: {
          label: 'مغلق',
        },
        hasBBB: {
          label: 'لديه BBB',
        }
        ,
        description: {
          label: 'وصف',
          required: 'الوصف مطلوب',
        },
        image: {
          required: 'صورة المنظمة مطلوبة',
        },
      },
      report: {
        order_status: 'حالة الطلب',
      },
      login: {
        connect: 'تسجيل الدخول',
        email: {
          label: 'عنوان البريد الإلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
      },
      profile: {
        update: 'تحديث',
        changePassword: 'تغيير كلمة المرور',
        name: {
          label: 'اسم',
          required: 'الاسم مطلوب',
        },
        email: {
          label: 'بريد إلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        phone: {
          label: 'هاتف',
          required: 'الهاتف مطلوب',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
        password_confirmation: {
          label: 'تأكيد كلمة المرور',
          required: 'مطلوب تأكيد كلمة المرور',
        },
        gender: {
          label:  "جنس",
          required:"مطلوب جنس",
        }
      },
      user: {
        type: {
          label: 'يكتب',
          required: 'النوع مطلوب',
        },
        category: {
          label: 'فئة',
          required: 'الفئة مطلوبة',
          placeholder: 'الرجاء التحديد',
        },
        name: {
          label: 'اسم',
          required: 'الاسم مطلوب',
        },
        email: {
          label: 'بريد إلكتروني',
          required: 'البريد الإلكتروني (مطلوب',
        },
        phone: {
          label: 'هاتف',
          required: 'الهاتف مطلوب',
        },
        gender: {
          label: 'جنس',
          required: 'جنس مطلوبة',
        },
        jobTitle: {
          label: 'مسمى وظيفي',
          required: 'المسمى الوظيفي مطلوب',
        },
        aboutMe: {
          label: 'ْعَنِّي',
          required: 'معلومات عني مطلوبة',
        },
        password: {
          label: 'كلمة المرور',
          required: 'كلمة المرور مطلوبة',
          minLength6: 'الحد الأدنى المطلوب 6 أحرف',
          unmatched: 'كلمة مرور لا مثيل لها',
        },
        password_confirmation: {
          label: 'تأكيد كلمة المرور',
          required: 'مطلوب تأكيد كلمة المرور',
        },
        image: {
          label: 'صورة',
          required: 'مطلوب صورة المستخدم',
        },
      },
      badge: {
        create: 'أنشئ شارة',
        numberOfCourses: {
          label: 'عدد الدورات',
          required: 'عدد الدورات المطلوبة',
        },
        edit:'تعديل الشارة',
        profile:'ملف تعريف الشارة',
      },
      banner: {
        create: 'إنشاء لافتة',
        edit: 'إنشاء لافتة',
        profile:'الملف الشخصي لافتة'
      },
      banners: {
        create: 'إنشاء لافتة',
      },
      // banner: {
      //   edit: 'إنشاء لافتة',
      // },
      student: {
        create: 'إنشاء لافتة',
      },
      
      instructor: {
        create: 'إنشاء لافتة',
      },
      package: {
        create: 'إنشاء الحزمة',
        price: {
          label: 'سعر',
          required: 'السعر مطلوب',
        },
        salePrice: {
          label: 'سعر البيع',
          required: 'سعر البيع مطلوب',
        },
        numberOfCourses: {
          label: 'عدد الدورات',
          required: 'عدد الدورات المطلوبة',
        },
        validity: {
          label: 'صلاحية',
          required: 'الصلاحية مطلوبة',
        },
        validityInMonths: {
          label: 'الصلاحية في شهور',
          required: 'الصلاحية مطلوبة',
        },
        image: {
          label: 'صورة',
          required: 'صورة البانر مطلوبة',
        },
      },
      category: {
        create: 'إنشاء فئة',
        choose: 'اختر الفئة',
      },
      page: {
        create: 'إنشاء صفحة',
        titleDe: {
          label: 'العنوان باللغة الألمانية',
          required: 'عنوان مطلوبة',
        },
        title: {
          label: 'العنوان باللغة الإنجليزية',
          required: 'عنوان مطلوبة',
        },
        descriptionDe: {
          label: 'الوصف باللغة الألمانية',
          required: 'الوصف مطلوب',
        },
        description: {
          label: 'الوصف باللغة الإنجليزية',
          required: 'الوصف مطلوب',
        },
        path: {
          label: 'طريق',
          required: 'المسار مطلوب',
        },
        type: {
          label: 'يكتب',
          required: 'النوع مطلوب',
        },
        numberOfCourses: {
          label: 'عدد الدورات',
          required: 'عدد الدورات المطلوبة',
        },

        image: {
          label: 'صورة',
          required: 'مطلوب صورة الشارة',
        },
      },
      level: {
        create: 'خلق المستوى',
        choose: 'اختر المستوى',
      },
      course: {
        create: 'إنشاء دورة',
        addedToFavSuccessfully: 'تمت الإضافة إلى المفضلة بنجاح',
        removedFromFavSuccessfully: 'تمت الإزالة من المفضلة بنجاح',
        linkCopiedSuccessFully: 'تم نسخ الرابط بنجاح',
        failed: 'فشل',
        average: 'متوسط',
        good: 'جيد',
        excellent: 'ممتاز',
        yourScore: 'درجاتك',
        totalScore: 'مجموع النقاط',
        percentage: 'نسبة مئوية',
        response: 'إجابة',
        plan: {
          label: 'يخطط',
          required: 'الخطة مطلوبة',
        },
        instructor: {
          label: 'مدرب',
          required: 'مطلوب مدرس',
        },
        level: {
          label: 'مستوى',
          required: 'المستوى مطلوب',
        },
        category: {
          label: 'فئة',
          required: 'الفئة مطلوبة',
        },
        isFeatured: {
          label: 'متميز',
          required: 'مطلوب مميز',
        },
        isPopular: {
          label: 'شائع',
          required: 'شائع مطلوب',
        },
        price: {
          label: 'سعر',
          required: 'السعر مطلوب',
        },
        salePrice: {
          label: 'سعر البيع',
          required: 'سعر البيع مطلوب',
          lessThanPrice: 'يجب أن يكون سعر البيع أقل من السعر',
        },
        image: {
          label: 'صورة',
          required: 'صورة الدورة التدريبية مطلوبة',
        },
      },
      meeting: {
        create: 'إنشاء اجتماع',
        titleDe: {
          label: 'العنوان باللغة الألمانية',
          required: 'عنوان مطلوبة',
        },
        title: {
          label: 'العنوان باللغة الإنجليزية',
          required: 'عنوان مطلوبة',
        },
        descriptionDe: {
          label: 'الوصف باللغة الألمانية',
          required: 'الوصف مطلوب',
        },
        description: {
          label: 'الوصف باللغة الإنجليزية',
          required: 'الوصف مطلوب',
        },
        isRecordingOn: {
          label: 'التسجيل قيد التشغيل',
          required: 'مطلوب التسجيل',
        },
        startDate: {
          label: 'تاريخ البدء',
          required: 'تاريخ البدء مطلوب',
          shouldBeGreaterThanToday: 'يجب أن يكون تاريخ البدء أكبر من اليوم',
        },
        endDate: {
          label: 'تاريخ الانتهاء',
          required: 'تاريخ الانتهاء مطلوب',
        },

        image: {
          label: 'صورة',
          required: 'مطلوب صورة الاجتماع',
        },
      },
      curriculum: {
        create: 'إنشاء منهج',
        edit:'تحرير',
        titleDe: {
          label: 'العنوان باللغة الألمانية',
          required: 'عنوان مطلوبة',
        },
        title: {
          label: 'العنوان باللغة الإنجليزية',
          required: 'عنوان مطلوبة',
        },
        descriptionDe: {
          label: 'الوصف باللغة الألمانية',
          required: 'الوصف مطلوب',
        },
        description: {
          label: 'الوصف باللغة الإنجليزية',
          required: 'الوصف مطلوب',
        },
        isRecordingOn: {
          label: 'التسجيل قيد التشغيل',
          required: 'مطلوب التسجيل',
        },
        sortOrder: {
          label: 'امر ترتيب',
          required: 'ترتيب الفرز مطلوب',
        },
        image: {
          label: 'صورة',
          required: 'صورة المنهاج مطلوبة',
        },
      },
      content: {
        create: 'إنشاء المحتوى',
        assignment: 'تكليف',
        scorm: 'سكورم',
        quiz: 'اختبار',
        html: 'لغة البرمجة',
        external_url: 'URL خارجي',
        vimeo_url: 'عنوان URL الخاص بـ فيميو',
        youtube_url: 'يوتيوب URL',
        titleDe: {
          label: 'العنوان باللغة الألمانية',
          required: 'Title مطلوبة',
        },
        title: {
          label: 'العنوان باللغة الإنجليزية',
          required: 'Title مطلوبة',
        },
        descriptionDe: {
          label: 'الوصف باللغة الألمانية',
          required: 'الوصف مطلوب',
          minLength20: 'مطلوب 20 حرفًا على الأقل',
        },
        description: {
          label: 'الوصف باللغة الإنجليزية',
          required: 'الوصف مطلوب',
          minLength20: 'مطلوب 20 حرفًا على الأقل',
        },
        isPreview: {
          label: 'معاينة',
          required: 'المعاينة مطلوبة',
        },
        type: {
          label: 'يكتب',
          required: 'النوع مطلوب',
        },
        sortOrder: {
          label: 'امر ترتيب',
          required: 'ترتيب الفرز مطلوب',
        },
        lectureType: {
          label: 'نوع المحاضرة',
          required: 'نوع المحاضرة مطلوب',
        },
        lecture: {
          label: 'محاضرة',
          video_id: 'معرف الفيديو',
          external_url: 'URL خارجي',
          vimeo_url: 'عنوان URL الخاص بـ فيميو',
          youtube_url: 'عنوان URL لموقع youtube',
        },
        generalInstructions: {
          label: 'تعليمات عامة',
          required: 'مطلوب تعليمات عامة',
          minLength20: 'مطلوب 20 حرفًا على الأقل',
        },
        image: {
          label: 'صورة',
          required: 'صورة المحتوى مطلوبة',
        },
      },
      courses: {
        purchaseCourseFirst: 'شراء الدورة أولا'
      },
      question: {
        create: 'إنشاء أسئلة',
        singleSelect: 'اختيار واحد',
        multiSelect: 'تحديد متعدد',
        numeric: 'رقمي',
        titleDe: {
          label: 'العنوان باللغة الألمانية',
          required: 'عنوان مطلوبة',
        },
        title: {
          label: 'العنوان باللغة الإنجليزية',
          required: 'عنوان مطلوبة',
        },
        descriptionDe: {
          label: 'الوصف باللغة الألمانية',
          required: 'الوصف مطلوب',
        },
        description: {
          label: 'الوصف باللغة الإنجليزية',
          required: 'الوصف مطلوب',
        },
        type: {
          label: 'يكتب',
          required: 'النوع مطلوب',
        },
        positiveMarks: {
          label: 'علامات إيجابية',
          required: 'مطلوب علامات إيجابية',
        },
        negativeMarks: {
          label: 'العلامات السلبية',
          required: 'مطلوب علامات سلبية',
        },
        option: {
          isCorrect: {
            label: 'هو خيار التصحيح',
          },
          title: {
            label: 'عنوان',
            required: 'مطلوبة عنوان',
          },
        },
        image: {
          label: 'صورة',
          required: 'صورة السؤال مطلوبة',
        },
      },
      review: {
        label: 'مراجعة',
        required: 'المراجعة مطلوبة',
      },
      rating: {
        label: 'تقييم',
        required: 'التقييم مطلوب',
      },
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    debug: true,

    //keySeparator: true, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;